module.exports = global["$"] = require("-!./jquery.js");


/*****************
 ** WEBPACK FOOTER
 ** ../~/expose-loader?$!../~/jquery/dist/jquery.js-exposed
 ** module id = 463
 ** module chunks = 19
 **/